// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"afcb8784","237":"2bc24725","254":"767b79f8","323":"24d48565","384":"8ff41f44","548":"fb766be8","627":"1d7d87c5","638":"b9b37318","646":"eb86e49b","682":"cbc11a40","979":"18476c57"}[chunkId] + ".chunk.js";
};